<script lang="ts" setup>
import { TaskViewElementEnum } from "@/components/tasks-kanban/enums";
import { ListItemModel } from "../../../models";
import { computed, CSSProperties, PropType } from "vue";

/**Параметры */
const props = defineProps({
  /**Данные об элемнте */
  element: { type: Object as PropType<ListItemModel> },
});

/**Стиль компонента */
const componentStyle = computed<CSSProperties>(() => ({
  width: props.element.Width,
  minWidth: props.element.MinWidth,
  flexShrink: props.element.MinWidth ? "0" : "1",
}));
</script>
<template>
  <div class="task-card-item-wrapper" :style="componentStyle">
    <slot />
  </div>
</template>
<style lang="scss" scoped>
.task-card-item-wrapper {
  display: flex;
  align-items: center;
  gap: 0.125rem;
  // margin-left: 0.2rem;
}

.task-card-end-style {
  display: flex;
  justify-content: flex-end;
}

.task-card-center-style {
  display: flex;
  justify-content: center;
}
</style>
